import React from 'react'
import classnames from 'classnames'
import imgResize from '@/utils/img-resize'
import styles from './index.module.less'
import appInstall from '@/utils/appUtils/appInstall'
import Jockeys from '@/utils/jockey'
import { isDuApp, compareVersion, getAppVersion } from '@/utils/appUtils/getDevice'
interface ItemProps {
  styleType: string
  item: {
    topIndexDes: string
    brandName: string
    topName: string
    spuLogoUrl: string
    spuName: string
    spuId: string
    topIndex: number
  }
  index: number
}

interface MainProps {
  children?: any
  styleType: string
}

const goDetail = (item) => {
  if (isDuApp() && compareVersion(getAppVersion(), '2.5.4') !== -1) {
    Jockeys.openNativePage('/product/rankings', {
      categoryId: item.categoryId,
      topType: item.topType,
      topId: item.topId,
    })
    return
  }
  appInstall('/product/rankings', {
    categoryId: item.categoryId,
    topType: item.topType,
    topId: item.topId,
  })
}

function Main(props: MainProps) {
  const imgMap = {
    yellow: [
      'https://cdn.poizon.com/node-common/b5bf155f06d9cbc8d8efbbebe1985efe.png',
      'https://cdn.poizon.com/node-common/b0319d1dd1a65d659c551e92e9c34fc4.png',
    ],
    blue: [
      'https://cdn.poizon.com/node-common/d85bca24aff3023fbeaa743a8e60712e.png',
      'https://cdn.poizon.com/node-common/28090ac8001d2d405f6d40c106986e8a.png',
    ],
  }
  return (
    <div
      className={classnames({
        [styles['main']]: true,
        [styles[props.styleType]]: true,
      })}
    >
      <img className={styles['ear-cover']} src={imgMap[props.styleType][0]} alt="" />
      <div className={styles['box']}>{props.children}</div>
      <img className={styles['ear-cover']} src={imgMap[props.styleType][1]} alt="" />
    </div>
  )
}

function Item({ item, index, styleType }: ItemProps) {
  return (
    <div className={styles['item']} onClick={() => goDetail(item)}>
      <Main styleType={styleType}>
        <div className={styles['cont']}>
          <div className={styles['brand']}>{item.brandName}</div>
          <div className={styles['title']}>{item.topName}</div>
        </div>
      </Main>
      <img className={styles['cover']} data-layzload-src={imgResize(item.spuLogoUrl, 160)} alt="" />
      <div className={styles['desc']}>
        {item.topIndexDes} <span className={styles['hot']}>{item.topIndex}</span>
      </div>
    </div>
  )
}

export default Item
